import React from 'react';
import './GenericModal.scss';
import Button from '@mui/material/Button';

interface GenericModalActionButtonProps {
  label: string;
  onClick: () => void;
  variant?: 'text' | 'outlined' | 'contained';
  color?:
    | 'primary'
    | 'secondary'
    | 'inherit'
    | 'success'
    | 'error'
    | 'info'
    | 'warning';
}

export interface GenericModalActionProps {
  primary: GenericModalActionButtonProps;
  secondary?: GenericModalActionButtonProps;
}

const GenericModalActions: React.FC<GenericModalActionProps> = ({
  primary,
  secondary,
}) => {
  const primaryVariant = primary.variant || 'contained';
  const primaryColor = primary.color || 'primary';
  const secondaryVariant = secondary?.variant || 'outlined';

  return (
    <div className="generic-modal-actions__wrapper">
      <div className="generic-modal-actions">
        <Button
          size="medium"
          variant={primaryVariant}
          color={primaryColor}
          onClick={primary.onClick}
        >
          {primary.label}
        </Button>

        {secondary && (
          <Button
            size="medium"
            variant={secondaryVariant}
            color="inherit"
            onClick={secondary.onClick}
          >
            {secondary.label}
          </Button>
        )}
      </div>
    </div>
  );
};

export default GenericModalActions;
